var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7915_1237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.09888 7.1001C8.78338 7.1001 10.1489 5.73454 10.1489 4.05005C10.1489 2.36555 8.78338 1 7.09888 1C5.41439 1 4.04883 2.36555 4.04883 4.05005C4.04883 5.73454 5.41439 7.1001 7.09888 7.1001Z",
    stroke: "#ABABAB",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1983 13.1993C13.2002 13.0741 13.2002 12.9469 13.2002 12.818C13.2002 10.923 10.4691 9.38672 7.1001 9.38672C3.73111 9.38672 1 10.923 1 12.818C1 14.7131 1 16.2493 7.1001 16.2493C8.80126 16.2493 10.028 16.1298 10.9127 15.9164",
    stroke: "#ABABAB",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7915_1237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person_icon.1753a4e3de0605dba43d162460b40202.svg";
export { ForwardRef as ReactComponent };